import Vue from 'vue';
import isUndefined from 'lodash/isUndefined';
import values from 'lodash/values';
import { fetchAppLocalizationData } from '@/settings/localization-settings/guide-localization.service.js';

export function getInitialState () {
    return {
        map: {},
        error: null,
    };
}

const localization = {
    namespaced: true,
    state: getInitialState(),
    mutations: {
        setMap (state, { appId, localizationData }) {
            Vue.set(state.map, appId, localizationData);
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async loadOne ({ commit, state }, { reFetch = false, appId } = {}) {
            if (!isUndefined(state.map[appId]) && !reFetch) {
                return;
            }

            try {
                const localizationData = await fetchAppLocalizationData(appId);
                commit('setMap', { appId, localizationData });
            } catch (error) {
                commit('setError', { error });
            }
        },
    },
    getters: {
        list: (state) => values(state.map),
    },
};

export default localization;
